import * as React from 'react';
import { safeNumericString } from 'app/infrastructure/data/sanitize';
import { deserializeConnectionState } from 'app/area/case/draft/connected-state';
import { Bowtie } from './bowtie';
import { BowtieDisplayMode } from './external-types';
import { WithRouterProps } from 'app/components/enhancers/with-router';

interface BowtieParams {
  id: string;
}

export const BowtieScreen: React.FC<React.PropsWithChildren<BowtieParams & WithRouterProps>> = (props) => {

  const caseNumber = safeNumericString(props.params.id);
  const connectedDrafts = deserializeConnectionState(props.router.location.query);

  if (caseNumber === '') {
    return null;
  }

  return <Bowtie
    caseNumber={caseNumber}
    connectedDrafts={connectedDrafts}
    favouriteId={undefined}

    displayMode={BowtieDisplayMode.fullscreen} />;
};
